/**
 * `?suite=` : la page ou la personne va une fois connectee (tache 6.2 du plan). C'est une adresse que n'importe qui peut ecrire :
 * un lien `/rejoindre?suite=//autre.site` serait une redirection ouverte. Seuls passent les chemins locaux, de la forme
 * `/^\/[a-z][a-z0-9/-]*$/` : une barre, une lettre, puis des lettres minuscules, des chiffres, des barres et des tirets. Donc ni
 * `//autre.site`, ni `/\autre.site`, ni un protocole (`https:`, `javascript:`), ni un point, un pourcent ou un deux-points, ni une
 * majuscule. Et ni une page de la regie, ni une page nue d'OBS, ni l'API : un viewer n'a rien a y faire, et `/rejoindre`
 * lui-meme ferait tourner la page en boucle.
 */
const CHEMIN_LOCAL = /^\/[a-z][a-z0-9/-]*$/;

/** Les premiers segments qu'une suite ne prend jamais. */
const SEGMENTS_REFUSES = ["regie", "overlay", "api", "rejoindre"];

/** Un chemin sur, ou `null` : la valeur n'est pas du texte, n'est pas un chemin local, ou mene ailleurs que vers une page de viewer. */
export function suiteSure(valeur: unknown): string | null {
  if (typeof valeur !== "string" || !CHEMIN_LOCAL.test(valeur)) return null;
  const premier = valeur.split("/")[1] ?? "";
  return SEGMENTS_REFUSES.includes(premier) ? null : valeur;
}

/** La page d'un viewer qui ne dit pas ou aller. Le ticket 6 y mettra `/boosters` quand des pochettes attendent. */
export const PAGE_PAR_DEFAUT = "/moi";

/**
 * Ou envoyer un viewer connecte : sa suite si elle est sure, sinon la page par defaut. `boostersScelles` est la pour le ticket 6 :
 * c'est ici qu'il choisira `/boosters` quand des pochettes attendent (point 6 de sa liste).
 */
export function pageDApres(suite: string | null, _boostersScelles: number): string {
  return suite ?? PAGE_PAR_DEFAUT;
}
